var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "发证",
        visible: _vm.showDialog,
        "append-to-body": "",
        width: "50%"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            size: "small",
            rules: _vm.rules,
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "发送方式", prop: "type" } },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.checkboxChange },
                  model: {
                    value: _vm.ruleForm.type,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "type", $$v)
                    },
                    expression: "ruleForm.type"
                  }
                },
                [
                  _c(
                    "el-checkbox-button",
                    { attrs: { label: "0", name: "type" } },
                    [_vm._v("邮件通知")]
                  ),
                  _c(
                    "el-checkbox-button",
                    { attrs: { label: "1", name: "type" } },
                    [_vm._v("手机短信通知")]
                  ),
                  _c(
                    "el-checkbox-button",
                    { attrs: { label: "2", name: "type" } },
                    [_vm._v("线下发送快递")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.showKD
            ? _c(
                "el-form-item",
                { attrs: { label: "快递公司", prop: "shipperName" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.ruleForm.shipperName,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "shipperName", $$v)
                        },
                        expression: "ruleForm.shipperName"
                      }
                    },
                    _vm._l(_vm.kuaidiOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showKD
            ? _c(
                "el-form-item",
                { attrs: { label: "物流单号", prop: "logisticCode" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.ruleForm.logisticCode,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "logisticCode", $$v)
                      },
                      expression: "ruleForm.logisticCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }